import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getVendorIdFromToken } from "../helpers/utils";

const initialState = {
  cartItemsState: {
    data: [], // Initial data as an empty array
    loading: false, // Represents whether the API call is in progress
    error: null, // Stores any errors from API calls
  }, // The state type is BaseState with an array of ICartItems as the data type
};

export const fetchCartItemsData = createAsyncThunk(
  "cartItems/fetchCartItemsData",
  async ({ items }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(fetchCartItemsStart());
      const vendorId = getVendorIdFromToken();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/e-commerce/cart-items`,
        {
          items,
          vendorId,
        }
      );
      dispatch(fetchCartItemsSuccess(response.data));
      return response;
    } catch (error) {
      const errorMsg = error?.message || "Something Went Wrong";
      dispatch(fetchCartItemsFailure(errorMsg));
      return rejectWithValue(errorMsg);
    }
  }
);

const cartItemsSlice = createSlice({
  name: "cartItems",
  initialState,
  reducers: {
    fetchCartItemsStart(state) {
      state.cartItemsState.loading = true;
      state.cartItemsState.error = null;
    },
    fetchCartItemsSuccess(state, action) {
      state.cartItemsState.loading = false;
      state.cartItemsState.data = action.payload;
      state.cartItemsState.error = null;
    },
    fetchCartItemsFailure(state, action) {
      state.cartItemsState.loading = false;
      state.cartItemsState.error = action.payload;
    },
  },
});

export const {
  fetchCartItemsStart,
  fetchCartItemsSuccess,
  fetchCartItemsFailure,
} = cartItemsSlice.actions;

export default cartItemsSlice.reducer;
